<template>
  <div class="reaction-bar" :class="{ compact }">
    <button
      type="button"
      class="reaction-btn"
      :class="{ active: userReaction === 'like' }"
      :disabled="disabled"
      @click="toggle('like')"
    >
      <span class="reaction-icon" aria-hidden="true">👍</span>
      <span class="reaction-count">{{ likesCount }}</span>
    </button>
    <button
      type="button"
      class="reaction-btn"
      :class="{ active: userReaction === 'dislike' }"
      :disabled="disabled"
      @click="toggle('dislike')"
    >
      <span class="reaction-icon" aria-hidden="true">👎</span>
      <span class="reaction-count">{{ dislikesCount }}</span>
    </button>
  </div>
</template>

<script setup>
const props = defineProps({
  likesCount: {
    type: Number,
    default: 0,
  },
  dislikesCount: {
    type: Number,
    default: 0,
  },
  userReaction: {
    type: String,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  compact: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['react', 'unreact'])

function toggle(value) {
  if (props.userReaction === value) {
    emit('unreact')
  } else {
    emit('react', value)
  }
}
</script>

<style scoped>
.reaction-bar {
  display: flex;
  gap: 0.5rem;
}

.reaction-bar.compact {
  gap: 0.375rem;
}

.reaction-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  padding: 0.375rem 0.75rem;
  background: #fff;
  color: #334155;
  cursor: pointer;
  font-size: 0.875rem;
}

.reaction-btn:hover:not(:disabled) {
  background: #f8fafc;
}

.reaction-btn.active {
  border-color: #2563eb;
  background: #eff6ff;
  color: #1d4ed8;
}

.reaction-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.reaction-bar.compact .reaction-btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.8125rem;
}

.reaction-count {
  min-width: 1ch;
}
</style>
